import { render, staticRenderFns } from "./BatchSet.vue?vue&type=template&id=686c4812&scoped=true"
import script from "./BatchSet.vue?vue&type=script&lang=js"
export * from "./BatchSet.vue?vue&type=script&lang=js"
import style0 from "./BatchSet.vue?vue&type=style&index=0&id=686c4812&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c4812",
  null
  
)

export default component.exports